import { useState } from "react";
import "./Paywall.css";
import { useTranslation } from "react-i18next";
import Backendcontroller from "../../Backendcontroller";

function Paywall (props) {

    const { t, i18n } = useTranslation();

    const detectDeviceType = () =>
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(navigator.userAgent)
        ? 'mobile'
        : 'desktop';

    const [contactData, setContactData] = useState({
        name: "",
        company: "",
        position: "",
        email: "",
        phone: ""
    });

    let penAndPaperSeconds = props.penAndPaperMinutes * 60 + props.penAndPaperSeconds;
    let deductionsSeconds = props.deductionsMinutes * 60 + props.deductionsSeconds;
    let kpisSeconds = props.kpisMinutes * 60 + props.kpisSeconds;

    let penAndPaperResults = {
        score: props.penAndPaperScore,
        step: 1,
        time: penAndPaperSeconds,
        device: detectDeviceType()
    };

    let deductionsResults = {
        score: props.deductionsScore,
        step: 2,
        time: deductionsSeconds,
        device: detectDeviceType()
    }

    let kpisResults = {
        score: props.kpisScore,
        step: 3,
        time: kpisSeconds,
        device: detectDeviceType()
    };

    const domain = Backendcontroller();

    async function onSubmitHandler (event) {
        event.preventDefault();

        const dummyScores = document.getElementsByName("score")
        let scores = []
        for (let s of dummyScores){
            console.log(s.textContent)
            scores.push(s.textContent)
        }

        const dummyTimes = document.getElementsByName("time")
        let times = []
        for (let t of dummyTimes){
            console.log(t.textContent)
            times.push(t.textContent)
        }

        //POST contactData
        fetch(`https://${domain}/api/ttpc_contact_data`, {
                method: "POST",
                mode: "no-cors",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(contactData)
            });

        //POST results
        fetch(`https://${domain}/api/ttpc_results`, {
            method: "POST",
            mode:"no-cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(penAndPaperResults)
        });

        fetch(`https://${domain}/api/ttpc_results`, {
            method: "POST",
            mode:"no-cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(deductionsResults)
        });

        fetch(`https://${domain}/api/ttpc_results`, {
            method: "POST",
            mode:"no-cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(kpisResults)
        });

        //GET averageScore
        fetch(`https://${domain}/api/ttpc_averagescore`, {
            method: "GET",
        }).then(function(res) {
            return res.json()
        }).then(function(data) {
            props.getAverageResults(data);
        })

        //POST data for email in backend
        const emailData = {
            name: contactData.name,
            email: contactData.email,
            language: i18n.language,
            scores: scores,
            times: times
        }
        fetch(`https://${domain}/api/ttpc_email`, {
            method: "POST",
            mode: "no-cors",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(emailData)
        })

        props.showButton(false);
        props.onExit();
        props.showEvaluation();


    }

    function handleChange(event) {
        setContactData({
            ...contactData,
            [event.target.name]: event.target.value
        });
    };

    return (
        <div>
            <div className="paywall-backdrop" onClick={props.onExit}></div>
            <div className="paywall-container">
                <header className="paywall-header">
                    <h1>{t("contact_data")}</h1>
                </header>
                <div className="paywall-content">
                    <p>{t("paywallText")}</p>
                    <form onSubmit={onSubmitHandler}>
                        <label>{t("name")}
                        <input type="text" name="name" onChange={handleChange} value={contactData.name} required></input>
                        </label>
                        <label>{t("company")}
                        <input type="text" name="company" onChange={handleChange} value={contactData.company} required></input>
                        </label>
                        <label>{t("position")}
                        <input type="text" name="position" onChange={handleChange} value={contactData.position} required></input>
                        </label>
                        <label>{t("email")}</label>
                        <input type="email" name="email" onChange={handleChange} value={contactData.email} required></input>
                        <label>{t("phone_number")}</label>
                        <input type="tel" name="phone" onChange={handleChange} value={contactData.phone} placeholder="(optional)"></input>
                        <input type="submit" value={t("send")}></input>
                    </form>
                    {(i18n.language === "de") ?
                        <a href="https://bisonaire.com/de/datenschutz" target="_blank" rel="noopener noreferrer">{t("privacy_policy")}</a> :
                        <a href="https://bisonaire.com/en/datenschutz" target="_blank" rel="noopener noreferrer">{t("privacy_policy")}</a>
                    }
                    
                </div>
            </div>
        </div>
    );
}

export default Paywall;